
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message } from "element-ui";

    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            keyword: '',
            bond_type: '',
            org_type: '',
            created_at: [],
            status: '',
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };

        // 查看
        toDetail(row: any) {
            this.$router.push({
                path: '/order/bussnessDetailYG',
                query: {
                    code: row.order_code,
                    look: 'true',
                    org_code: row.org_code
                }
            })
        }
        //日志
        logDialog = false
        logTable = []
        logTotal = 0
        logInfo = {}
        logSearch = {
            id: '',
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            }
        }
        toLog(row: any) {
            this.logInfo = row
            this.logSearch.id = row.id
            api.post('A17003', this.logSearch).then(res => {
                this.logTable = res.list
                this.logTotal = res.total
                this.logDialog = true
            })
        }

        // 搜索 search:true 重置翻页
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A17001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        activated() {
            this.searchTable();
        }
    }
